import { BaseText } from "./text";

export class BaseButton extends BaseText {}
